import { API_BASE_URL, api } from './client'

export interface InvoiceSettings {
    id: string
    company_name: string
    company_address: string
    company_phone: string
    company_tax_code?: string
    company_logo?: string
    bank_name?: string
    bank_account?: string
    bank_holder?: string
    footer_note?: string
    vat_percent: number
    misa_ip_template_id?: string
    misa_inv_series?: string
    updated_at: string
}

export interface UpdateSettingsRequest {
    company_name: string
    company_address: string
    company_phone: string
    company_tax_code?: string
    bank_name?: string
    bank_account?: string
    bank_holder?: string
    footer_note?: string
    vat_percent?: number
    misa_ip_template_id?: string
    misa_inv_series?: string
}

export interface BatchExportRequest {
    order_ids: string[]
    type: 'invoice' | 'stock_out_note'
}

export const invoiceApi = {
    getSettings: () => api.get<InvoiceSettings>('/invoices/settings'),
    updateSettings: (data: UpdateSettingsRequest) =>
        api.put<InvoiceSettings>('/invoices/settings', data),

    // PDF download URLs (used as href for direct browser download)
    getInvoicePdfUrl: (orderId: string) =>
        `${API_BASE_URL}/invoices/sales-orders/${orderId}/invoice`,
    getPackingSlipPdfUrl: (orderId: string) =>
        `${API_BASE_URL}/invoices/sales-orders/${orderId}/packing-slip`,

    // Batch export returns a zip blob
    batchExport: async (data: BatchExportRequest): Promise<Blob> => {
        const response = await fetch(`${API_BASE_URL}/invoices/batch-export`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(data),
        })
        if (!response.ok) {
            throw new Error('Failed to export batch')
        }
        return response.blob()
    },
}
